<template>
  <div class="bar_wrap">
    <div ref="barcharts" id="barcharts" class="barcharts"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
let tooltip = {
  trigger: 'axis',
  axisPointer: {          // 坐标轴指示器，坐标轴触发有效
    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
  },
  confine: true
},
  grid = {
    left: 20,
    right: 20,
    bottom: 15,
    top: 10,
    containLabel: true
  };
var option = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
      type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
    },
    extraCssText: 'width:100%;white-space: normal; word-break: break-all;',
    textStyle: {
      align: 'left'
    },


    confine: true,
    // formatter: `扫描区域：${'b0'}{b0} <br /> 本次数值: {c0} <br /> 标准范围: ≥ {c1}，越高越好`,
    formatter: function (params, ticket, callback) {
      console.log(params)
      let qname = ''
      if(params[0].name == 'β细胞功能'){
      qname = '胰岛细胞对于血糖有调节作用。 胰岛β细胞分泌胰岛素，是检测糖代谢异常病理生理的重要部分。'
     }else if(params[0].name == '葡萄糖耐量受损'){
      qname = '糖耐量受损是一种由正常血糖向糖尿病过渡的异常糖代谢状态，主要表现为餐后血糖升高。其诊断标准为：患者做口服葡萄糖耐量试验时空腹血糖正常（小于6.0mmol/L），但口服糖后2个小时的血糖在7.8-11.1mmol/L之间，该数值大于正常值，但同时又达不到糖尿病的诊断标准，该状态即为糖耐量受损，属于糖尿病前期，可能进一步发展为糖尿病。'
     }else if(params[0].name == '胰岛素抵抗'){
      qname = '胰岛素抵抗是指各种原因使胰岛素促进葡萄糖摄取和利用的效率下降，机体代偿性的分泌过多胰岛素产生高胰岛素血症，以维持血糖的稳定。胰岛素抵抗易导致代谢综合征和2型糖尿病。50年代Yallow等应用放射免疫分析技术测定血浆胰岛素浓度，发现血浆胰岛素水平较低的病人胰岛素敏感性较高，而血浆胰岛素较高的人对胰岛素不敏感，由此提出了胰岛素抵抗的概念。'
     }else if(params[0].name == '心血管'){
      qname = '糖尿病心血管并发症：包括心脏和大血管上的微血管病变、心肌病变、心脏自主神经病变，引起糖尿病患者死亡的首要病因。冠心病是糖尿病的主要大血管并发症，研究显示，糖尿病患者冠心病的死亡风险比非糖尿患者群高3～5倍。其病理机制是动脉粥样硬化，高血糖、高收缩压、高胆固醇、低密度脂蛋白增高、高密度脂蛋白下降、年龄、性别、吸烟、家族史均是其发病的危险因素。'
     }else if(params[0].name == '肾'){
      qname = '糖尿病肾病：是糖尿病患者最重要的合并症之一。我国的发病率亦呈上升趋势，目前已成为终末期肾脏病的第二位原因，仅次于各种肾小球肾炎。由于其存在复杂的代谢紊乱，一旦发展到终末期肾脏病，往往比其他肾脏疾病的治疗更加棘手。但积极适当的干预措施能明显减少和延缓糖尿病肾病的发生，尤其在病程早期干预治疗效果甚佳。'
     }else if(params[0].name == '眼底'){
      qname = '糖尿病眼部并发症（1）糖尿病性视网膜病变：是糖尿病性微血管病变中最重要的表现，是一种具有特异性改变的眼底病变，是糖尿病的严重并发症之一。（2）与糖尿病相关的葡萄膜炎：大致上有以下4种情况：①与糖尿病本身相关的葡萄膜炎；②感染性葡萄膜炎，糖尿病患者发生内源性感染性眼内炎的机会较正常人明显增加；③伴有一些特定的葡萄膜炎类型，但二者是偶然的巧合，抑或是有内在的联系；④内眼手术后的感染性眼内炎或无菌性眼内炎。多发生于中年人和老年人糖尿病患者。（3）糖尿病性白内障：发生在血糖没有很好控制的青少年糖尿病患者。多为双眼发病，发展迅速，甚至可于数天、数周或数月内发展为完全混浊。'
     }else if(params[0].name == '下肢'){
      qname = '糖尿病足：足部是糖尿病这个多系统疾病的一个复杂的靶器官。糖尿病患者因周围神经病变与外周血管疾病合并过高的机械压力，可引起足部软组织及骨关节系统的破坏与畸形形成，进而引发一系列足部问题，从轻度的神经症状到严重的溃疡、感染、血管疾病、Charcot关节病和神经病变性骨折。实际上类似的病理改变也可以发生在上肢、面部和躯干上，不过糖尿病足的发生率明显高于其他部位。'
     }
      return `${qname} <br /> 本次数值：${params[0].value} <br /> 标准范围：≤40，越低越好`
    }
  },

  grid: grid,
  xAxis: [
    {
      type: 'value',
      min: 0,
      max: 100,
      axisLine: {
        lineStyle: {
          color: '#999'
        }
      },
      data: [0, 20, 40, 60, 80, 100],
    },
    {
      position: 'top',
      name: '',
      data: ['一级', '二级', '三级', '四级', '五级'],
      axisLine: { //坐标轴线
        show: false,
      },
      axisTick: { //坐标轴刻度轴
        show: false
      }
    }
  ],
  yAxis: [
    {
      type: 'category',
      axisTick: { show: false },
      data: [],
      axisLine: {
        lineStyle: {
          color: '#999'
        }
      },
      axisLabel: {
        //interval: 0,
        //rotate: 20, 
        color: '#666',
        fontSize:16
      },
    }
  ],
  series: [
    {
      name: '风险数值',
      type: 'bar',
      barWidth: 22,
      barGap: '10%',
      label: {
        normal: {
          show: true,
          position: 'inside',
          textStyle: {	    //数值样式
            color: '#fff',
            fontSize: 16
          }
        }
      },
      data: [],
      itemStyle: {
        normal: {
          color: function (params) {
            let colorList = [];
            let value = params.value;
            if (value >= 0 && value <= 20) {
              colorList = ['#009944', '#4EDD8E']
            }
            if (value > 20 && value <= 40) {
              colorList = ['#A2E317', '#4EDD8E']
            }
            if (value > 40 && value <= 60) {
              colorList = ['#FF9294', '#FFC17F']
            }
            if (value > 60 && value <= 80) {
              colorList = ['#FF5409', '#FFB080']
            }
            if (value > 80 && value <= 100) {
              colorList = ['#DD352A', '#F27269']
            }
            return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: colorList[0] },
              { offset: 1, color: colorList[1] }
            ]);
          },
          barBorderRadius: 2 //柱状角成椭圆形
        }
      }
    },
  ]
};
var option2 = {
  tooltip: tooltip,
  grid: grid,
  xAxis: [
    {
      type: 'value',
      min: -100,
      max: 100,
      axisLine: {
        lineStyle: {
          color: '#999'
        }
      },
      data: [-100, -60, -20, 0, 60, 100],
    },
    {
      position: 'top',
      name: '',
      data: ['中度减退', '轻度减退', '最佳', '最佳', '轻度亢进', '中度亢进'],
      axisLine: { //坐标轴线
        show: false,
      },
      axisTick: { //坐标轴刻度轴
        show: false
      }
    }
  ],
  yAxis: [
    {
      type: 'category',
      axisTick: { show: false },
      data: [],
      axisLine: {
        lineStyle: {
          color: '#999'
        }
      },
      axisLabel: {
        //interval: 0,
        //rotate: 20, 
        color: '#666'
      },
    }
  ],
  series: [
    {
      name: '修复数值',
      type: 'bar',
      barWidth: 22,
      barGap: '10%',
      label: {
        normal: {
          show: true,
          position: 'inside',
          textStyle: {	    //数值样式
            color: '#fff',
            fontSize: 12
          }
        }
      },
      data: [],
      itemStyle: {
        normal: {
          color: function (params) {
            let colorList = [];
            let value = params.value;
            if (value >= -20 && value <= 20) {
              colorList = ['#009944', '#4EDD8E'] // 绿色
            }
            if (value >= 21 && value <= 100) {
              colorList = ['#FFAE04', '#FFD630'] // 橙色
            }
            if (value >= -100 && value <= -21) {
              colorList = ['#189FFC', '#9CD8FF'] // 蓝色
            }
            return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: colorList[0] },
              { offset: 1, color: colorList[1] }
            ]);
          },
          barBorderRadius: 2 //柱状角成椭圆形
        }
      }
    },
  ]
};
export default {
  props: {
    barlist: {
      type: Array,
      default() {
        return []
      },
    },
    ifClick: {
      type: Boolean,
      default() {
        return false
      },
    },
    min: {
      type: Number,
      default() {
        return 0
      },
    },
    max: {
      type: Number,
      default() {
        return 100
      },
    },
  },
  data() {
    return {
    }
  },
  methods: {
    initCharts() {
      let charts = this.$echarts.init(this.$refs.barcharts);

      if (this.min === -100) {
        option2.yAxis[0].data = this.barlist.map(e => {
          return e.name
        })
        option2.series[0].data = this.barlist.map(e => {
          return e.functional_status
        });
        charts.setOption(option2);
      } else {
        option.yAxis[0].data = this.barlist.map(e => {
          return e.name
        })
        option.series[0].data = this.barlist.map(e => {
          return e.functional_status
        });
        charts.setOption(option);
      }
      let that = this
      charts.on('click', function (params) {
        console.log('paramsbar', params.name)
        if (that.ifClick) {
          that.$emit('handle-organ', params.name)
        }
      });
    }
  },
  created() {
    this.$nextTick(() => {
      this.initCharts()
    })
  }
}
</script>
<style lang="scss" scoped>
.barcharts {
  width: 700px;
  height: 610px;
}
</style>